import type { StylableElementProps } from '@subaio/components'
import { renderIdentifier } from '@subaio/utils'

import { Image } from './Image'
import abnAmro from './images/abnamro.png'
import bankdataSydbank from './images/bankdata_sydbank.png'
import becArbejderneslandsbank from './images/bec_albank.svg'
import becBec from './images/bec_bec.svg'
import coopbank from './images/bec_coopbank.svg'
import becAndelskassen from './images/bec_dab.png'
import becFælleskassen from './images/bec_faelleskassen.svg'
import becFasterOikos from './images/bec_fasteroikos.svg'
import becFrønslevmollerup from './images/bec_fmspks.jpg'
import becFrørup from './images/bec_froerupak.png'
import becFynskebank from './images/bec_fynskebank.png'
import becGrøndslandbanken from './images/bec_grbanken.png'
import becHvidbjerg from './images/bec_hvidbjergbank.png'
import becLollandsbank from './images/bec_lobk.jpg'
import becLægernesbank from './images/bec_lpb.jpg'
import becMerkur from './images/bec_merkur.svg'
import becMønsbank from './images/bec_moensbank.png'
import becNykredit from './images/bec_nykredit.svg'
import becPensam from './images/bec_pensambank.svg'
import becSparekassen from './images/bec_spard.svg'
import becSparnord from './images/bec_sparnord.svg'
import becVestjyskbank from './images/bec_vestjysk.svg'
import betalingsservice from './images/betalingsservice.png'
import experian from './images/experian.png'
import festina from './images/festina.png'
import intesasanpaolo from './images/intesasanpaolo.png'
import lunar from './images/lunar.png'
import nordea from './images/nordea.svg'
import optimabank from './images/optimabank.png'
import pleo from './images/pleo.png'
import santander from './images/santander.png'
import spv from './images/spv.png'
import spvBulder from './images/spv_bulder.png'
import subaio from './images/subaio.svg'
import uniify from './images/uniify.png'

const brands = {
	abnamro: abnAmro,

	bankdata_sydbank: bankdataSydbank,

	betalingsservice,

	bec_arbejderneslandsbank: becArbejderneslandsbank,
	bec_nykredit: becNykredit,
	bec_sparnord: becSparnord,
	becbudget_albank: becArbejderneslandsbank,
	becbudget_coopbank: coopbank,
	becbudget_dab: becAndelskassen,
	becbudget_froerupak: becFrørup,
	becbudget_faelleskassen: becFælleskassen,
	becbudget_fasteroikos: becFasterOikos,
	becbudget_fmspks: becFrønslevmollerup,
	becbudget_fynskebank: becFynskebank,
	becbudget_grbanken: becGrøndslandbanken,
	becbudget_hvidbjergbank: becHvidbjerg,
	becbudget_lobk: becLollandsbank,
	becbudget_lpb: becLægernesbank,
	becbudget_merkur: becMerkur,
	becbudget_moensbank: becMønsbank,
	becbudget_nykredit: becNykredit,
	becbudget_pensambank: becPensam,
	becbudget_spard: becSparekassen,
	becbudget_sparnord: becSparnord,
	becbudget_vestjysk: becVestjyskbank,
	becbudget_internal: becBec,
	becbudget_subaio: subaio,
	becfestina_albank: becArbejderneslandsbank,
	becfestina_coopbank: coopbank,
	becfestina_dab: becAndelskassen,
	becfestina_froerupak: becFrørup,
	becfestina_faelleskassen: becFælleskassen,
	becfestina_fasteroikos: becFasterOikos,
	becfestina_fmspks: becFrønslevmollerup,
	becfestina_fynskebank: becFynskebank,
	becfestina_grbanken: becGrøndslandbanken,
	becfestina_hvidbjergbank: becHvidbjerg,
	becfestina_lobk: becLollandsbank,
	becfestina_lpb: becLægernesbank,
	becfestina_merkur: becMerkur,
	becfestina_moensbank: becMønsbank,
	becfestina_nykredit: becNykredit,
	becfestina_pensambank: becPensam,
	becfestina_spard: becSparekassen,
	becfestina_sparnord: becSparnord,
	becfestina_vestjysk: becVestjyskbank,
	becfestina_internal: becBec,
	becfestina_subaio: subaio,

	coopbank,

	festina,

	intesasanpaolo,

	lunar,
	lunarbusiness: lunar,

	noitso_santander: santander,
	noitso_lunar: lunar,
	noitso: experian,
	experian,

	nordea,
	nordeapeb: nordea,
	nordeabudget: nordea,
	nordeabudget_subaio: subaio,

	optimabank,

	pleo,

	santander,

	spv_bulderbank: spvBulder,
	spv,

	uniify,

	sales: subaio,
	subaio,
	subhub: subaio,
} as Record<string, string>

export const getImage = (partialBrandId?: string): string | undefined => {
	if (!partialBrandId) return undefined
	if (brands[partialBrandId]) return brands[partialBrandId]

	return getImage(partialBrandId.substring(0, partialBrandId.lastIndexOf('_')))
}

type Props = StylableElementProps & {
	brandId?: string
	height: number
	defaultImage?: string
}

export const BrandLogo = ({ brandId, height, defaultImage, className, style }: Props) => {
	const imageUrl = getImage(brandId) ?? defaultImage

	return imageUrl ? (
		<Image src={imageUrl} height={height} className={className} style={style} />
	) : (
		renderIdentifier(brandId ?? '')
	)
}
